import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Carrousel } from "./Carrousel";
import { vedettes } from "../data/mockData";

/** Première diapositive : Geodonnée elle-même, avec le titre de la page. */
const accueil = {
  nom: "Geodonnée",
  image: "/captures/viewer-paris.webp",
  alt: "LizPack Viewer : stations Vélib' de Paris regroupées en hexagones de 500 m, colorés selon leur nombre, avec les espaces verts et les arrondissements.",
};

const Capture = ({ image, alt, i }) => (
  <div className="overflow-hidden rounded-[16px] border border-border bg-white shadow-[0_2px_10px_rgba(8,61,68,0.08)]">
    <img
      src={image}
      alt={alt}
      width={1440}
      height={900}
      loading={i === 0 ? "eager" : "lazy"}
      decoding="async"
      className="block h-auto w-full"
    />
  </div>
);

/**
 * Une diapositive : le titre et l'action à gauche, la capture à droite ;
 * sur téléphone, le titre d'abord, puis la capture.
 */
const Diapositive = (d, i) => (
  <div className="grid items-start gap-6 lg:grid-cols-12 lg:gap-12">
    <div className="diapo-texte min-w-0 lg:col-span-5 lg:pt-6">
      {i === 0 ? (
        <>
          <h1 className="font-display text-vt-hero-compact font-extrabold leading-[1.1] tracking-[-0.03em] text-brand">
            Vos données géospatiales, <em>traitées, automatisées</em> et
            diffusées.
          </h1>
          <p className="lede mt-4 lg:mt-6">
            Automatisation, cartes web, développement sur mesure,
            sous-traitance, diffusion avec LizPack et formation de vos
            équipes, depuis Gatineau.
          </p>
          <div className="mt-6 flex flex-wrap gap-3 lg:mt-8 lg:gap-4">
            {/* Sur téléphone, le menu porte déjà « Consultation gratuite ». */}
            <Link to="/#contact" className="btn-accent hidden sm:inline-flex">
              Consultation gratuite
              <ArrowRight className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" />
            </Link>
            {/* Seul bouton sur téléphone : vert ; à côté de la consultation : secondaire. */}
            <Link
              to="/#services"
              className="btn-accent sm:border-border sm:bg-white sm:text-brand sm:hover:bg-white"
            >
              Nos services
            </Link>
          </div>
        </>
      ) : (
        <>
          <h2 className="font-display text-vt-hero-compact font-extrabold leading-[1.1] tracking-[-0.03em] text-brand">
            {d.nom}
          </h2>
          <p className="mt-3 font-display text-vt-h3 font-bold leading-[1.2] text-accent lg:mt-4 lg:text-vt-h2">
            {d.accroche}
          </p>
          <p className="mt-4 leading-relaxed text-t2 lg:mt-5 lg:text-vt-chapo">{d.texte}</p>
          <div className="mt-6 flex flex-wrap gap-4 lg:mt-8">
            <a href={d.lien} target="_blank" rel="noopener noreferrer" className="btn-accent">
              {d.lienLibelle}
              <ArrowUpRight className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" />
              <span className="sr-only">(nouvel onglet)</span>
            </a>
            <Link to="/#contact" className="btn-outline hidden sm:inline-flex">
              Nous écrire
            </Link>
          </div>
        </>
      )}
    </div>
    <div className="diapo-image min-w-0 lg:col-span-7">
      <Capture image={d.image} alt={d.alt} i={i} />
    </div>
  </div>
);

export const Hero = () => (
  <section
    id="accueil"
    className="hero-plein flex flex-col justify-center bg-bg2 px-6 pb-8 pt-24 sm:px-10 lg:px-12 lg:pb-10 lg:pt-28"
  >
    <div id="plateformes" className="mx-auto w-full max-w-[1760px] scroll-mt-28">
      <Carrousel
        diapositives={[accueil, ...vedettes]}
        libelle="Geodonnée et ses plateformes : LizPack Viewer, LizPack Field, LizPack et GeoServer Cloud"
        nom={(d) => d.nom}
        rendu={Diapositive}
      />
    </div>
  </section>
);
